import {Directive, ElementRef, HostListener, Input, OnInit,} from '@angular/core';
@Directive({
  selector: '[appDecimalNumber]'
})
export class DecimalNumberDirective implements OnInit{
  @Input('wholeNumber')  wholeNumber: string;
  @Input('fractional') fractional: string;
  private regex: RegExp;
  private specialKeys: Array<string> = ['Backspace', 'Tab', 'End', 'Home', 'ArrowLeft', 'ArrowRight', 'Del', 'Delete'];
  constructor(private el: ElementRef) {

  }
  ngOnInit(){
    this.regex =  new RegExp('\^\\d{0,' + this.wholeNumber + '}\\.?\\d{0,' + this.fractional + '}$')
  }
  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    // Allow Backspace, tab, end, and home keys
    if (this.specialKeys && this.specialKeys.indexOf(event.key) !== -1) {
      return;
    }
    let current: string = this.el.nativeElement.value;
    const position = this.el.nativeElement.selectionStart;
    const next: string = [current.slice(0, position), event.key == 'Decimal' ? '.' : event.key, current.slice(position)].join('');
    if (next && !String(next).match(this.regex)) {
      event.preventDefault();
    }
  }
}